type FormatMimeTypes = Record<string, string[]>;

const formatMimeTypes: FormatMimeTypes = {
  xls: [
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel.sheet.macroenabled.12',
  ],
  img: ['image/jpeg', 'image/png'],
  pdf: ['application/pdf'],
  doc: ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
  ppt: ['application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation'],
};

export function getFormats(): string[] {
  return Object.keys(formatMimeTypes);
}

export function getFormat(mimeType: string): string | undefined {
  return Object.entries(formatMimeTypes).reduce<string | undefined>(
    (acc, [format, mimeTypes]) => mimeTypes.includes(mimeType) ? format : acc,
    undefined,
  );
}
